import { Box, Icon, Prose, Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  data: {
    details: string
    topMatch: boolean
    score: number
  }
}

export const CandidateAIHighlights = ({ data }: Props) => {
  const parsedDetails = JSON.parse(data.details)
  const highlights = parsedDetails.highlights

  return (
    <Box
      padding="s4"
      paddingTop="s12"
      gap="s12"
      borderRadius={{ all: 'abs012' }}
      background="purple200"
    >
      <Tag type="purple" icon="ai" iconColor="grey800" inline>
        <Box flexDirection="row" gap="s8" alignItems="center">
          <Icon.Small icon="ai" color="grey800" />
          {i18n.t('ats.candidate_details.ai_summary_title')}
        </Box>
      </Tag>
      <Box padding="s12" borderRadius={{ all: 'abs010' }} background="lighter320">
        <Prose size="200" fullWidth>
          <ul>
            {highlights &&
              highlights.map((highlight: string, index: number) => (
                <li key={index}>{highlight}</li>
              ))}
          </ul>
        </Prose>
      </Box>
    </Box>
  )
}
